var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.yearItems.length > 1
        ? _c(
            "div",
            [
              _c(
                "v-row",
                _vm._l(_vm.chartGrid, function (chart, cIndex) {
                  return _c(
                    "v-col",
                    { key: cIndex, attrs: { cols: "12", lg: "6" } },
                    [
                      _c("PlotlyWrapper", {
                        attrs: { data: chart.data, layout: chart.layout },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", lg: "4" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6", lg: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c("v-card-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.outputs.elccPercentage[0].toFixed(1)
                                      ) + " %"
                                    ),
                                  ]),
                                  _c("v-card-text", [_vm._v("ELCC")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6", lg: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c("v-card-title", [
                                    _vm._v(
                                      _vm._s(_vm.outputs.elccMegawatts[0]) +
                                        " MW"
                                    ),
                                  ]),
                                  _c("v-card-text", [
                                    _vm._v("Qualifiying Capacity"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", lg: "8" } },
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.tableHeaders,
                          items: _vm.singleYearTableItems,
                          "hide-default-footer": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c("v-divider"),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", lg: "2" } },
                    [
                      _c("v-select", {
                        attrs: {
                          width: "200",
                          label: "Year",
                          items: _vm.yearItems,
                          "item-text": "year",
                          "item-value": "index",
                        },
                        model: {
                          value: _vm.selectedYear,
                          callback: function ($$v) {
                            _vm.selectedYear = $$v
                          },
                          expression: "selectedYear",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                _vm._l(_vm.yearlyChartGrid, function (chart, cIndex) {
                  return _c(
                    "v-col",
                    { key: cIndex, attrs: { cols: "12", lg: "6" } },
                    [
                      _c("PlotlyWrapper", {
                        attrs: { data: chart.data, layout: chart.layout },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }